import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type DeliveriesFilters,
  type DeliveriesPage,
} from "../../../domain/entities/all-deliveries";
import { type AllDeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listDeliveries = createAsyncThunk<
  DeliveriesPage,
  DeliveriesFilters,
  { dispatch: AllDeliveriesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_DELIVERIES, async (filters, { extra }) => {
  return await extra.allDeliveriesRepo.listDeliveries(filters);
});

export const loadMore = createAsyncThunk<
  DeliveriesPage,
  DeliveriesFilters,
  { dispatch: AllDeliveriesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOAD_MORE, async (filters, { extra }) => {
  return await extra.allDeliveriesRepo.listDeliveries(filters);
});
